<template>
    <!--定点投放 新增渠道码/编辑渠道码 对话框 -->

    <el-dialog title="编辑渠道码" :visible.sync="show" :with-header="false" :before-close="closeDialog" width="50%">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="80px">
                    <el-form-item label="渠道码名称:" label-width="120px">
                        <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 60%"> </el-input>
                    </el-form-item>

                    <el-form-item label="投放类目:" label-width="120px" v-if="data.editFlag == 'edit'">
                        <el-select v-model="cateName" placeholder="请选择类目" style="width: 60%" @change="cateChange" clearable="">
                            <el-option
                                v-for="(item, index) in categoryLists"
                                :key="index"
                                :label="item.name"
                                :value="item.promotion_category_code"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="投放类目:" label-width="120px" v-else>
                        <el-select
                            v-model="submit_data.promotion_category_code"
                            placeholder="请选择类目"
                            style="width: 60%"
                            @change="cateChange"
                            clearable=""
                        >
                            <el-option
                                v-for="(item, index) in categoryLists"
                                :key="index"
                                :label="item.name"
                                :value="item.promotion_category_code"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="投放时间:" label-width="120px">
                        <el-date-picker
                            v-model="search_time"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            style="width: 60%"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center; margin-top: 100px">
                    <submitBtn
                        @onSubmitDig="onSubmitDig"
                        :data="submit_data"
                        :rules="submit_rules"
                        :url="submit_url"
                        :JSON_Boolean="true"
                        @toJSON="toJSON"
                    ></submitBtn>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-dialog>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.promotionCategoryLists();

            if (_this.data.editFlag == 'edit') {
                console.log(_this.data, '编辑');
                // 如果是编辑按钮点击进来的
                _this.submit_url = '/promotion/editPromotionQR';
                let start = _this.data.market_time.slice(0, 10);
                let end = _this.data.market_time.slice(11);

                _this.search_time.push(start, end);
                _this.submit_data_edit.name = _this.data.name;
                // 当时新增这条数据的时候，类目可能是启用状态，但是后期禁用了，或者删除了，不存在的，需求要求显示，但是不可以提交，不可以再次选择

                _this.submit_data_edit.promotion_qr_code = _this.data.promotion_qr_code;
                _this.submit_data_edit.promotion_category_code = _this.data.promotion_category_code;
                _this.cateName = _this.data.promotion_category_name;

                _this.submit_data = _this.submit_data_edit;
                console.log(_this.submit_data, '_this.submit_data');
            } else if (_this.data.editFlag == 'add') {
                _this.submit_url = '/promotion/addPromotionQR';
                _this.submit_data = _this.submit_data_add;
            }
        }
    },
    data() {
        return {
            show: false,
            cateName: '',
            categoryLists: [],
            search_data_list: {
                // 投放类目查询
                page: 1,
                limit: 10
            },
            search_time: [],

            submit_url: '/promotion/addPromotionQR',
            submit_data: {},
            promotion_category_name: '',

            // 表单数据
            submit_data_add: {
                name: '',

                promotion_category_code: '',
                fixed_array: ''
            },
            submit_data_edit: {
                name: '',
                promotion_category_code: '',
                promotion_qr_code: '',
                fixed_array: ''
            },

            submit_rules: {
                name: {
                    placeholder: '渠道码名称',
                    rules: {
                        required: true,
                        message: '渠道码名称十个字以内',
                        regulation: 'between_str',
                        rulesData: [2, 10]
                    }
                },

                promotion_category_code: {
                    placeholder: '投放类目',
                    rules: {
                        required: true,
                        message: '投放类目错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                fixed_array: {
                    placeholder: '投放时间',
                    rules: {
                        required: true,
                        message: '投放时间错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        cateChange(val) {
            _this.submit_data.promotion_category_code = val;
            for (let i = 0; i < _this.categoryLists.length; i++) {
                console.log(val, 'change的值====');
                console.log(_this.categoryLists[i].promotion_category_code, '数组里的值====');
                _this.$nextTick(function () {
                    if (val == _this.categoryLists[i].promotion_category_code) {
                        _this.cateName = _this.categoryLists[i].name;
                    }
                });
                break;
                // if (val == _this.categoryLists[i].promotion_category_code) {
                //     _this.data.promotion_category_name = _this.categoryLists[i].name;
                //     console.log(_this.data.promotion_category_name,'_this.data.promotion_category_name');
                //     break
                // }
            }
        },
        promotionCategoryLists() {
            console.log(_this.search_data_list, '_this.search_data_list');
            _this
                .$post('/promotion/getPromotionCategoryStatus', _this.search_data_list)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.categoryLists.push({ name: res.data[i].name, promotion_category_code: res.data[i].promotion_category_code });
                    }

                    // 如果一次接口请求数据少于全部数据就再次请求
                    if (_this.search_data_list.page * _this.search_data_list.limit < res.data.count) {
                        _this.promotionCategoryLists();
                    }
                })
                .catch((err) => {});
        },
        toJSON() {
            _this.submit_data.fixed_array = JSON.stringify(['between', ..._this.search_time]);
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.categoryLists = [];
            _this.search_data_list = {
                // 投放类目查询
                page: 1,
                limit: 10
            };
            _this.search_time = [];

            _this.submit_url = '/promotion/addPromotionQR';
            _this.submit_data = {};

            // 表单数据
            _this.submit_data_add = {
                name: '',

                promotion_category_code: '',
                fixed_array: ''
            };
            _this.submit_data_edit = {
                name: '',
                promotion_category_code: '',
                promotion_qr_code: '',
                fixed_array: ''
            };
        },

        // 提交
        onSubmitDig() {
            _this.$emit('onSubmit');
            _this.closeDialog();
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
